import _ from 'lodash'
import { MutationTree } from 'vuex'
import { SearchContactLensState, } from './types'

export const mutations: MutationTree<SearchContactLensState> = {
  setCsvData(state, payload: string[][]) {
    state.csvData = payload
  },
}
